import type { TableDropdownOption } from '../tableSystem/tableToolbar.types';

export type MetricsToolbarTagOption = string | TableDropdownOption;

export const normaliseMetricsToolbarTagOptions = (
  availableTags: readonly MetricsToolbarTagOption[],
): TableDropdownOption[] =>
  availableTags.map((tag) => (typeof tag === 'string' ? { value: tag, label: tag } : tag));
